"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateRoot = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@remix-run/react");
const react_2 = require("react");
const client_1 = require("react-dom/client");
function hydrateRoot() {
    const hydrate = () => {
        (0, react_2.startTransition)(() => {
            (0, client_1.hydrateRoot)(document, (0, jsx_runtime_1.jsx)(react_2.StrictMode, { children: (0, jsx_runtime_1.jsx)(react_1.RemixBrowser, {}) }));
        });
    };
    if (window.requestIdleCallback) {
        window.requestIdleCallback(hydrate);
    }
    else {
        // Safari doesn't support requestIdleCallback
        // https://caniuse.com/requestidlecallback
        window.setTimeout(hydrate, 1);
    }
}
exports.hydrateRoot = hydrateRoot;
